<template>
	<div
		v-if="!$root.web"
		:id="$style.menubar"
		:class="$style[$settings.env]"
	>
		<div class="flex-row d-flex w-100 h-100">
			<div
				:class="$style.logo"
				class="text-white text-bold"
			>
				GESTIOS{{ $settings.env === 'development' ? ': Modo de pruebas' : '' }}
			</div>
			<div :class="$style.separator" />
			<div :class="$style.controls">
				<div
					:class="$style.minimize"
					@click="minimize"
				>
					<fa-icon
						:icon="['fa','minus']"
						class="text-white"
					/>
				</div>
				<div
					:class="$style.close"
					@click="close"
				>
					<fa-icon
						:icon="['fa','times']"
						class="text-white"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	methods: {
		minimize() {
			this.window.minimize();
		},
		close() {
			this.window.close();
		}
	}
};
</script>

<style lang="scss" module>
@import './style.module.scss';
</style>
